module.exports = __webpack_public_path__ + "img/bg5.c6f1b765.png";